import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { CalculationInformation } from '@/app/api/morgan-thermal/calculation';

export const enableCalculation = createEndpoint<Informative>(({fetch}) => (id: CalculationInformation['id']) => fetch(`/Calculation/Enable/${id}`, {method: 'POST'}));